
import React, { useState } from 'react';
import { Mail, Send, LockKeyhole, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface QuickEmailTransferProps {
  className?: string;
}

const QuickEmailTransfer: React.FC<QuickEmailTransferProps> = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Please enter an email address');
      return;
    }
    
    // Redirect to PIN transfer page with email pre-filled
    navigate('/pin-transfer', { state: { email } });
  };

  return (
    <div className={`p-6 bg-white rounded-2xl shadow-sm ${className}`}>
      <div className="flex items-center gap-2 mb-4">
        <div className="p-2 bg-blue-100 rounded-full">
          <Mail className="h-5 w-5 text-blue-600" />
        </div>
        <h2 className="font-semibold text-lg text-gray-900">Quick Email Transfer</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Input
            type="email"
            placeholder="Recipient's email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full"
            required
          />
        </div>

        <Button 
          type="submit" 
          className="w-full flex items-center justify-center gap-2"
        >
          <Send className="h-4 w-4" />
          Continue to PIN Transfer
          <LockKeyhole className="h-4 w-4" />
        </Button>

        <div className="flex items-center justify-center mt-2">
          <div className="flex items-center text-xs text-gray-500">
            <AlertTriangle className="h-4 w-4 text-amber-500 mr-1" />
            <p>All transfers now require PIN verification</p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default QuickEmailTransfer;
